module.exports = __webpack_public_path__ + "img/14.03937ccb.png";